export function createScript(src) {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = src;
    const scriptElement = document.body.appendChild(s);
    return scriptElement;
}
// 确定Accept.js脚本有没有加载
